import { Form } from './modules/form-validate/form';
import { iosVhFix } from './utils/ios-vh-fix';
import { initBurger } from './modules/header/init-burger';
import { initMenuCategory } from './modules/header/init-menu-category.js';
import { initMenuHide } from './modules/header/menu-hide.js';
import { initShowPassword } from './modules/init-show-password.js';
import { initTabs } from './modules/tabs/initTabs.js';
import { initFancybox } from './modules/init-fancybox.js';
import { initBtnUp } from './modules/init-btn-up.js';
import { initSelectedCheckbox } from './modules/init-selected-checkbox.js';
import { initCollapseBlock } from './modules/init-collapse-block.js';
import { initSearchBlock } from './modules/init-search-block.js';
import { initActive } from './modules/init-active.js';
import { initSelect } from './modules/init-select.js';
import { initSwiper } from './modules/swipers/init-swiper.js';
import { initScrollEl } from './modules/init-scroll-el.js';
import { initDelivery } from './modules/init-delivery.js';

window.appConfig = {
  breakpointTablet: 768,
  breakpointDeskTop: 1200
};

// const breakpoint = 768;

// ---------------------------------

window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------

  iosVhFix();

  // Modules
  // ---------------------------------

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initBurger();

    if (window.appConfig.breakpointTablet <= window.innerWidth) {
      initMenuHide();
      initMenuCategory();
    }

    const form = new Form();
    window.form = form;
    form.init();

    initShowPassword();

    initTabs();
    initFancybox();
    initBtnUp();
    initSelectedCheckbox();
    initCollapseBlock();
    initSearchBlock();
    initActive();
    initSelect();
    initSwiper();
    initScrollEl();
    initDelivery();
  });
});
